// extracted by mini-css-extract-plugin
module.exports = {"figure":"Images_figure__y2GIS","Image":"Images_Image__0NnPi","Svg":"Images_Svg__HMOr5"};